var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-md-7 login-left d-none d-md-block" }, [
    _c(
      "div",
      {
        staticClass:
          "h-full d-flex flex-column align-items-center justify-content-between"
      },
      [
        _c("a", { attrs: { href: _vm.getClientAppUrl, target: "_blank" } }, [
          _c("img", {
            staticClass: "login-logo pointer",
            attrs: { src: require("../../../assets/img/white-1x.png") }
          })
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "changed-router-links pointer",
            attrs: { href: _vm.getForemanUrl, target: "_blank" }
          },
          [_vm._m(1)]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("img", {
        staticClass: "login-pc",
        attrs: { src: require("../../../assets/img/login-pc.svg") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "under-pc-text" }, [
        _vm._v("Track all your moves in one place")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "foreman-retangle row align-items-center" },
      [
        _c("div", { staticClass: "col-md-3 foreman" }, [
          _vm._v("Are you a foreman?")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-8 foreman-desscription-txt" }, [
          _vm._v(
            "We’re currently working on a native app for Android and iOS. For now you can login to your account and track moves on our web app."
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-1 foreman-arrow" }, [
          _c("i", { staticClass: "fa fa-long-arrow-right" })
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2efb4a8a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2efb4a8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/components/LayoutLeftAuth.vue
// module id = null
// module chunks = 